module.exports = __webpack_public_path__ + "static/media/PhotoCamera.eda657be.svg";